import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

const CaregiverCreate = (props) => {
  return (
    <Stack>

    </Stack>
  );
};
CaregiverCreate.propTypes = {
  oldData: PropTypes.object.isRequired,
  newData: PropTypes.object.isRequired,
};

export default React.memo(CaregiverCreate);
